import { z } from "zod";

export namespace CryptoModels {
  export const GetDisperseRewardStatusResponseSchema = z.object({
    status: z.enum(["pending", "unclaimed", "filled", "unavailable"]),
  });
  export type GetDisperseRewardStatusResponse = z.infer<typeof GetDisperseRewardStatusResponseSchema>;

  /**
   * GetCryptoSymbolsResponseSchema
   * @type { object }
   * @description Response schema for GET /crypto/symbols
   */
  export const GetCryptoSymbolsResponseSchema = z.object({
    symbols: z.array(z.string()),
  });
  export type GetCryptoSymbolsResponse = z.infer<typeof GetCryptoSymbolsResponseSchema>;

  /**
   * DisperseRewardRequestSchema
   * @type { object }
   * @description Request body for POST /crypto/disperse-reward
   */
  export const DisperseRewardRequestSchema = z.object({
    symbols: z.array(z.string()),
  });
  export type DisperseRewardRequest = z.infer<typeof DisperseRewardRequestSchema>;

  /**
   * DisperseRewardResponseSchema
   * @type { object }
   * @description Response schema for POST /crypto/disperse-reward
   */
  export const DisperseRewardResponseSchema = z.object({
    status: z.enum(["pending", "unclaimed", "filled", "unavailable"]),
  });
  export type DisperseRewardResponse = z.infer<typeof DisperseRewardResponseSchema>;

  /**
   * CryptoPositionSchema
   * @type { object }
   * @description Schema for a single crypto position
   */
  export const CryptoPositionSchema = z.object({
    symbol: z.string(),
    quantity: z.string(),
    totalCost: z.string(),
    totalNetLiq: z.string(),
  });
  export type CryptoPosition = z.infer<typeof CryptoPositionSchema>;

  /**
   * GetCryptoPositionsResponseSchema
   * @type { array }
   * @description Response schema for GET /crypto/positions
   */
  export const GetCryptoPositionsResponseSchema = z.object({
    positions: z.array(CryptoPositionSchema),
    totalCost: z.string().nullable(),
    totalNetLiq: z.string().nullable(),
  });
  export type GetCryptoPositionsResponse = z.infer<typeof GetCryptoPositionsResponseSchema>;
}
